import React from 'react'
import '../styles/stepProgress.css'
import { useSelector, useDispatch } from 'react-redux'
import { setCurrentSlide } from 'store/CustomReports/actions'
import { mandatorySlides, optionalSlides } from './data'
import _ from 'lodash'

const StepProgress = ({ steps }) => {
  const dispatch = useDispatch()
  const { currentSlide, continueDisabled, exactReportType, completedSlides } =
    useSelector((store) => store.customReports)

  const goToStep = (index) => {
    if (continueDisabled && index >= currentSlide) return

    dispatch(setCurrentSlide(index + 1))
  }

  const disableCircle = (index) => {
    if (exactReportType !== null) {
      const mandatory = mandatorySlides?.[exactReportType]

      const lastMandatorySlide = mandatorySlides?.[exactReportType]
        ?.slice(-1)
        ?.at(0)

      const mandatoryNotCompleted = !_.every(mandatory, (slide) =>
        completedSlides.includes(slide)
      )

      if (index + 1 > lastMandatorySlide && mandatoryNotCompleted) return true
    }
    return false
  }

  return (
    <div className='container position-relative d-none d-lg-block'>
      <div className='step-progress'>
        {steps &&
          steps.length &&
          steps.map((label, index) => (
            <div className='step-container' key={index}>
              {index !== 0 && (
                <div
                  className={`line ${index < currentSlide ? 'active' : ''}`}
                ></div>
              )}
              <div
                className={`progress-circle ${
                  disableCircle(index) ? 'disabled' : ''
                }  ${index < currentSlide ? 'active' : ''}`}
                onClick={() => goToStep(index)}
              >
                {index + 1}
              </div>
              <div className='line-label'>{label}</div>
            </div>
          ))}
      </div>
    </div>
  )
}

export default StepProgress
